/**
 * Service: membership
 */
angular.module('acme.common.service.membership', [
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.permissions'
])
.service('MembershipService', ['$rootScope', '$filter', 'HelpersService', 'CalendarService', 'PermissionsService', function($rootScope, $filter, HelpersService, CalendarService, PermissionsService) {

    return {

      model: {},

      // This is an annoying hack, avoids API calls, but likely error prone
      purchaseTerm: false,

      salesChannels: [
        {
          name: 'Web',
          channel: 'online',
          enabled: true
        },
        {
          name: "Point of Sale",
          channel: "pointOfSale",
          enabled: true
        },
        {
          name: "Reseller",
          channel: "reseller",
          enabled: true
        },
        {
          name: "Inside Sales Individual",
          channel: "insideSalesIndividual",
          enabled: true
        },
        {
          name: "Customer Rep",
          channel: "customerRep",
          enabled: true
        },
        {
          name: "Manual Entry",
          channel: "manualEntry",
          enabled: true
        },
        {
          name: "SalesForce",
          channel: "salesforce",
          enabled: true
        },
        {
          name: "Kiosk",
          channel: "kiosk",
          enabled: true
        }
      ],

      membershipLevelGroups: [
        {
          name: 'individualAndFamily',
          label: 'Individual & Family'
        },
        {
          name: 'organization',
          label: 'Organizations'
        }
      ],

      purchaseTypes: {
        'new_memberships': {
          name: 'MembershipPurchase',
          label: 'New Purchase',
          action: 'NEW_MEMBERSHIPS'
        },
        'upgrade': {
          name: 'MembershipUpgrade',
          label: 'Upgrade',
          action: 'UPGRADE'
        },
        'renew': {
          name: 'MembershipRenewal',
          label: 'Renew',
          action: 'RENEW'
        },
        'postTermRenew': {
          name: 'MembershipPostTermRenewal',
          label: 'Renew (After term)',
          action: 'AFTER_TERM_RENEW'
        },
        'rejoin': {
          name: 'MembershipRejoin',
          label: 'Rejoin',
          action: 'REJOIN'
        },
        'renewUpgrade': {
          name: 'MembershipRenewalUpgrade',
          label: 'Renew (Upgrade)',
          action: 'RENEW'
        },
        'postTermRenewUpgrade': {
          name: 'MembershipPostTermRenewalUpgrade',
          label: 'Renew (After term upgrade)',
          action: 'AFTER_TERM_RENEW'
        },
        'rejoinUpgrade': {
          name: 'MembershipRejoinUpgrade',
          label: 'Rejoin (Upgrade)',
          action: 'REJOIN'
        },
        'renewDowngrade': {
          name: 'MembershipRenewalDowngrade',
          label: 'Renew (Downgrade)',
          action: 'RENEW'
        },
        'postTermRenewDowngrade': {
          name: 'MembershipPostTermRenewalDowngrade',
          label: 'Renew (After term downgrade)',
          action: 'AFTER_TERM_RENEW'
        },
        'rejoinDowngrade': {
          name: 'MembershipRejoinDowngrade',
          label: 'Rejoin (Downgrade)',
          action: 'REJOIN'
        },
        'downgrade': {
          name: 'MembershipDowngrade',
          label: 'Downgrade',
          action: 'DOWNGRADE'
        },
        'cancel': {
          name: 'MembershipCancel',
          label: 'Cancel',
          action: 'CANCELLATION'
        }
      },

      purchaseTypeDisplay: {
        'new_memberships': 'MembershipPurchase',
        'upgrade': 'MembershipUpgrade',
        'renew': 'MembershipRenewal',
        'postTermRenew': 'MembershipPostTermRenewal',
        'rejoin': 'MembershipRejoin',
        'renewUpgrade': 'MembershipRenewalUpgrade',
        'postTermRenewUpgrade': 'MembershipPostTermRenewalUpgrade',
        'rejoinUpgrade': 'MembershipRejoinUpgrade',
        'renewDowngrade': 'MembershipRenewalDowngrade',
        'postTermRenewDowngrade': 'MembershipPostTermRenewalDowngrade',
        'rejoinDowngrade': 'MembershipRejoinDowngrade',
        'downgrade': 'MembershipDowngrade',
        'cancel': 'MembershipCancel'
      },

      renewPurchaseTypes: [
        'MembershipRenewal',
        'MembershipPostTermRenewal',
        'MembershipRejoin',
        'MembershipRenewalUpgrade',
        'MembershipPostTermRenewalUpgrade',
        'MembershipRejoinUpgrade',
        'MembershipRenewalDowngrade',
        'MembershipPostTermRenewalDowngrade',
        'MembershipRejoinDowngrade'
      ],

      upgradeDowngradePurchaseTypes: [
        'MembershipUpgrade',
        'MembershipDowngrade'
      ],

      rejoinPurchaseTypes: [
        'MembershipPostTermRenewal',
        'MembershipRejoin',
        'MembershipPostTermRenewalUpgrade',
        'MembershipRejoinUpgrade',
        'MembershipPostTermRenewalDowngrade',
        'MembershipRejoinDowngrade'
      ],

      init: function(membership) {
        if (membership) {
          this.setModel(membership);
        }else{
          this.resetModel();
        }
      },

      setModel: function(model) {
        model = model || {};
        if (!this.validateSalesChannels(model)) {
          model.salesChannels = angular.copy(this.salesChannels);
        }
        if (!this.validateImages(model)) {
          model.images = [];
        }
        this.model = model;
        $rootScope.$broadcast('MembershipService::Update');
      },

      getModel: function() {
        // Seed ticket details in case it does not exist
        //this.getCategoryDetails();
        return this.model;
      },

      resetModel: function() {
        this.setModel({
          name: '',
          description: '',
          shortDescription: '',
          state: 'draft',
          salesChannels: angular.copy(this.salesChannels),
          benefits: [],
          offerings: [],
          rules: {
            numberOfCardHolders: 2,
            canGift: false,
            startBeginningOfMonth: false,
            expireEndOfMonth: false
          },
          images: [],
          termsAndConditions: ''
        });
      },

      hasMembershipMapping: function() {
        return (this.model.types instanceof Array && this.model.types[0]);
      },

      getMembershipMapping: function() {
        return (this.hasMembershipMapping()) ? this.model.types : [];
      },

      setMembershipMapping: function(memberships, defaultType) {
        this.model.types = memberships;

        //TODO: change this so that the actual primary membership mapping is set in the UI!!!
        if(defaultType) {
          this.model.defaultType = {
            program: defaultType.program,
            category: defaultType.category,
            subcategory: defaultType.subcategory,
            id: defaultType.id
          };
        } else if (this.model.types instanceof Array && this.model.types.length == 1) {
          this.model.defaultType = {
            program: this.model.types[0].program,
            category: this.model.types[0].category,
            subcategory: this.model.types[0].subcategory,
            id: this.model.types[0].id
          };
        } else if (this.model.types instanceof Array && this.model.types.length < 1) {
          this.model.defaultType = null;
        }

      },

      generateConfirmationEmailRestrictions: function() {

        var i, ii,
            r = [],
            salesChannels = ['online', 'pointOfSale', 'insideSalesIndividual', 'salesforce', 'customerRep', 'kiosk'];

        for (i=0,ii=salesChannels.length;i<ii;i++) {
          r.push({
            saleChannel: salesChannels[i],
            canSendConfirmationEmail: true
          });
        }

        return r;

      },

      createOfferingAction: function() {
        return {
          action: '',
          ruleIds: [],
          salesChannels: angular.copy(this.salesChannels),
          confirmationEmailRestrictions: this.generateConfirmationEmailRestrictions(),
          printMembershipCards: true,
          includeDigitalMemberCardsInConfirmationEmail: true,
          confirmationMessage: ''
        };
      },

      getReviewState: function() {
        return this.model.state;
      },

      setReviewState: function(state) {
        this.model.state = state;
      },

      findSalesChannel: function(salesChannels, channel) {

        var i, ii,
            r = false;

        for (i = 0, ii = salesChannels.length; i < ii; i++) {
          if (salesChannels[i].channel === channel) {
            r = {
              salesChannel: salesChannels[i],
              index: i
            };
            // Special case for membership
            if (channel === 'insideSalesIndividual') {
              r.salesChannel.label = 'Backoffice (B2B)';
            }else if (channel === 'online') {
              r.salesChannel.label = 'Consumer Web (B2C)';
            }else if (channel === 'pointOfSale') {
              r.salesChannel.label = 'Point of Sale (POS)';
            }else if (channel === 'salesforce') {
              r.salesChannel.label = 'Salesforce';
            }else if (channel === 'customerRep') {
              r.salesChannel.label = 'Customer Rep. (CSR)';
            } else  if (channel === 'manualEntry') {
              r.salesChannel.label = 'Manual Entry';
            } else  if (channel === 'reseller') {
              r.salesChannel.label = 'Reseller';
            } else  if (channel === 'kiosk') {
              r.salesChannel.label = 'Kiosk';
            } else  if (channel === 'collaborator') {
              r.salesChannel.label = 'Collaborator';
            }
            break;
          }
        }

        return r;

      },

      getMembershipLevelGroups: function() {
        return angular.copy(this.membershipLevelGroups);
      },

      getSalesChannels: function(channels) {
        var i, ii,
          _channels = [];

        for (i=0,ii=channels.length;i<ii;i++) {
          if (channels[i].enabled) {
            _channels.push(channels[i].label);
          }
        }

        return (_channels.length === channels.length) ? 'All' : _channels.join(', ');
      },

      orderSalesChannels: function(salesChannels) {
        var i, ii,
          channels = [],
          _channels = [],
          order = ['online', 'pointOfSale', 'individualInsideSales', 'salesforce', 'reseller', 'customerRep', 'manualEntry'];

        if (salesChannels instanceof Array) {
          for (i=0,ii=salesChannels.length;i<ii;i++) {
            if (order.length && order[0] == salesChannels[i].channel) {
              channels.push(salesChannels[i]);
              order.shift();
            }else{
              _channels.push(salesChannels[i]);
            }
          }

          salesChannels = channels.concat(_channels);
        }

        return salesChannels;
      },

      validateSalesChannels: function(membership) {
        return membership && membership.salesChannels instanceof Array;
      },

      validateImages: function(membership) {
        return membership && membership.images instanceof Array;
      },

      getPrimaryPhoto: function() {
        var i, ii;
        if (this.model.images instanceof Array) {
          for (i = 0, ii = this.model.images.length; i < ii; i++) {
            if (this.model.images[i].id === this.selectedPrimaryPhoto) {
              return this.model.images[i].screen;
            }
          }
        }
      },

      hasImages: function() {
        return (this.model.images instanceof Array);
      },

      hasPrice: function() {
        return this.model.price;
      },

      getPurchaseType: function(itemType) {
        var type,
            r = '';

        for (type in this.purchaseTypes) {
          if (this.purchaseTypes.hasOwnProperty(type)) {
            if (type === itemType) {
              r = this.purchaseTypes[type].name;
            }
          }
        }

        return r;
      },

      getActionFromPurchaseType: function(purchaseType) {
        var type,
          r = '';

        for (type in this.purchaseTypes) {
          if (this.purchaseTypes.hasOwnProperty(type)) {
            if (this.purchaseTypes[type].name === purchaseType) {
              r = type;
            }
          }
        }

        return r;
      },

      getEmailActionFromPurchaseType: function(purchaseType) {
        var type,
          r = '';

        for (type in this.purchaseTypes) {
          if (this.purchaseTypes.hasOwnProperty(type)) {
            if (this.purchaseTypes[type].name === purchaseType) {
              r = this.purchaseTypes[type].action;
            }
          }
        }

        return r;
      },

      hasSingleOffering: function(offerings) {
        var r = false;

        if (offerings.length === 1) {
          r = true;
        }

        return r;
      },

      hasSinglePricepoint: function(offerings) {
        var r = false;

        if (offerings.length === 1 &&
            (offerings[0].priceLists instanceof Array && (offerings[0].priceLists.length === 1)) &&
            (offerings[0].priceLists[0].prices instanceof Array && (offerings[0].priceLists[0].prices.length <= 1))) {
          r = true;
        }

        return r;
      },

      getFirstPricepoint: function(offering) {
        var r = null;

        if ( offering.priceLists instanceof Array && (offering.priceLists.length === 1) &&
            ((offering.priceLists[0].prices instanceof Array) && offering.priceLists[0].prices.length) ) {
          r = offering.priceLists[0].prices[0];
        }

        return r;
      },

      getMembershipDuration: function(offerings) {
        var r;

        if (offerings instanceof Array && offerings.length){
          if (offerings.length > 1) {
            r = 'Varies';
          } else {
            if (offerings[0].duration) {
              r = HelpersService.getFormattedDuration(offerings[0].duration);
            }
          }
        }

        return r;
      },

      getMembershipTerm: function(offerings) {
        var r = [];

        if (offerings instanceof Array && offerings.length){
          if (offerings.length > 1) {
            r.push('Varies');
          } else {
            if (offerings[0].membershipStartDate) {
              r.push($filter('date')(CalendarService.parseDate(offerings[0].membershipStartDate), HelpersService.dateFormats.standardDate));
            } else {
              r.push($filter('date')(new Date(), HelpersService.dateFormats.standardDate));
            }

            if (offerings[0].membershipExpirationDate) {
              r.push($filter('date')(CalendarService.parseDate(offerings[0].membershipExpirationDate), HelpersService.dateFormats.standardDate));
            } else {
              if (offerings[0].duration) {
                var currentDate = new Date();
                r.push($filter('date')(currentDate.setMonth(currentDate.getMonth() + offerings[0].duration), HelpersService.dateFormats.standardDate));
              }
            }
          }
        }
        return r.join(' - ');
      },

      getMembershipTermFromStartEnd: function(start, end) {
        return [
          $filter('date')(CalendarService.parseDate(start), HelpersService.dateFormats.standardDate),
          $filter('date')(CalendarService.parseDate(end), HelpersService.dateFormats.standardDate)
        ].join(' - ');
      },

      getOfferingSummary: function(offerings) {
        var r = '';

        if (this.hasSingleOffering(offerings)) {
          if (this.getFirstPricepoint(offerings[0])) {
            r = offerings[0].name;
          } else {
            r = 'Not available';
          }
        } else {
          r = offerings.length + ' Offerings';
        }

        return r;
      },

      getPriceRange: function(offerings) {
        var prices = [],
            minPrice = null,
            maxPrice = null,
            priceRange = [];

        angular.forEach(offerings, function(offering) {
          if (offering.priceLists instanceof Array && offering.priceLists.length &&
            (offering.priceLists[0].prices instanceof Array && offering.priceLists[0].prices.length)) {
            prices = offering.priceLists[0].prices;

            if (minPrice === null) {
              minPrice = HelpersService.currencyFloatToInteger(prices[0].discountedPrice || 0, 2);
            }
            if (maxPrice === null) {
              maxPrice = HelpersService.currencyFloatToInteger(prices[0].discountedPrice || 0, 2);
            }

            angular.forEach(prices, function(price) {
              minPrice = Math.min(minPrice, HelpersService.currencyFloatToInteger(price.discountedPrice, 2));
              maxPrice = Math.max(maxPrice, HelpersService.currencyFloatToInteger(price.discountedPrice, 2));
            });
          }

        });

        if (minPrice !== null) {
          priceRange.push($filter('currency')(HelpersService.integerToCurrencyFloat(minPrice, 2)));
        }

        if ((maxPrice !== null) && (maxPrice !== minPrice)) {
          priceRange.push($filter('currency')(HelpersService.integerToCurrencyFloat(maxPrice, 2)));
        }

        return priceRange.join(' - ');
      },

      getNumOfCardHolders: function(rules) {
        if (rules && rules.numberOfCardHolders != null) {
          return rules.numberOfCardHolders.toString();
        }

        return '1';
      },

      getAuxGroup: function(membershipLevelCollection) {
        if (membershipLevelCollection instanceof Array) {
          return membershipLevelCollection[0].name;
        }
        return null;
      },

      /**
       * @note Hide Aux Memberships from the list for New Membership Sales
       * @link https://acmeticketing.atlassian.net/browse/ENG-11091
       *
       * @param {{ auxiliary: boolean; offerings: Array }} level
       * @param {string} purchaseType
       */
      filterLevelOfferingsByPurchaseType: function (level, purchaseType) {
        var self = this;
        var offerings = Array.isArray(level.offerings) ? level.offerings : [];
        var isAuxiliary = level.auxiliary === true;
    
        return offerings.filter(function (offering) {
          var actions = Array.isArray(offering.actions) ? offering.actions : [];
          var selectedAction = actions.find(function (action) {
            return purchaseType.includes(action.action);
          });
    
          var salesChannels = selectedAction && Array.isArray(selectedAction.salesChannels)
              ? selectedAction.salesChannels
              : [];
    
          var channelRule = salesChannels.find(function (salesChannel) {
            return salesChannel.channel === 'insideSalesIndividual';
          });
    
          if (channelRule.enabled !== true) {
            return false;
          }
    
          switch (purchaseType) {
            case self.purchaseTypes['new_memberships'].action:
              return isAuxiliary === false;
    
            default:
              return true;
          }
        });
      },

      /**
       * Only applies filtering if purchaseType is defined
       * @param {*} levels Membership eligibility levels
       * @param {string | undefined} purchaseType Action name
       * @returns {Array<any>}
       */
      flattenLevelByOfferings: function(levels, purchaseType) {
        var self = this;
        var list = [];

        angular.forEach(levels, function(level) {
          // Based on the purchase type we filter out offerings that are not available to this sales channel
          var filteredOfferings = purchaseType
            ? self.filterLevelOfferingsByPurchaseType(level, purchaseType)
            : level.offerings;

          // If we have a non-empty offering list, we assign that to the level and flatten
          if (filteredOfferings.length > 0) {
            level.offerings = filteredOfferings;
            list = list.concat([
              {
                membershipLevelName: level.name,
                offerings: self.getOfferingSummary(level.offerings),
                type: level.purchaseTypeLabel,
                numOfOfferings: level.offerings.length,
                term: self.getMembershipTerm(level.offerings),
                duration: self.getMembershipDuration(level.offerings),
                cardHolders: self.getNumOfCardHolders(level.rules),
                priceRange: self.getPriceRange(level.offerings),
                level: level,
                auxGroup: self.getAuxGroup(level.membershipLevelCollection),
                hasSinglePricepoint: self.hasSinglePricepoint(level.offerings)
              }
            ]);
          }
        });

        return list;
      },

      /**
       * Item type should be the name property of purchaseTypes
       *
       * @param itemType
       * @returns {string}
       */
      getLifeCycleLabel: function(itemType) {
        var r = this.getMembershipTypeLabelByName(itemType);
        return 'Membership' + (r ? ' ' + r : '');
      },

      getMembershipTypeLabel: function(itemType) {
        var type,
            r = '';

        for (type in this.purchaseTypes) {
          if (this.purchaseTypes.hasOwnProperty(type)) {
            if (type === itemType) {
              r = this.purchaseTypes[type].label;
            }
          }
        }

        return r;
      },

      getMembershipTypeLabelByName: function(name) {
        var type,
          r = '';

        for (type in this.purchaseTypes) {
          if (this.purchaseTypes.hasOwnProperty(type)) {
            if (this.purchaseTypes[type].name === name) {
              r = this.purchaseTypes[type].label;
            }
          }
        }

        return r;
      },

      checkSendConfirmationForChannel: function(confirmationEmailRestrictions, saleChannel) {
        var r = false,
          i, ii;

        confirmationEmailRestrictions = confirmationEmailRestrictions instanceof Array ? confirmationEmailRestrictions : [];

        if (saleChannel) {
          for (i = 0, ii = confirmationEmailRestrictions.length; i < ii; i++) {
            if (confirmationEmailRestrictions[i] && confirmationEmailRestrictions[i].hasOwnProperty('saleChannel') &&
              (confirmationEmailRestrictions[i].saleChannel === saleChannel) &&
              confirmationEmailRestrictions[i].canSendConfirmationEmail) {
              r = true;
            }
          }
        }
        return r;
      },

      canSendMemberCardsForAction: function(membershipOffering, action) {
        var r = false,
          i, ii,
          isCSR = PermissionsService.check('CSR'),
          channel = isCSR ? 'customerRep' : 'insideSalesIndividual';

        if (membershipOffering && action && membershipOffering.actions instanceof Array) {
          for (i = 0, ii = membershipOffering.actions.length; i < ii; i++) {
            if (membershipOffering.actions[i].action && (membershipOffering.actions[i].action.toUpperCase() === action.toUpperCase())) {
              r = this.checkSendConfirmationForChannel(membershipOffering.actions[i].confirmationEmailRestrictions, channel);
            }
          }
        }
        return r;
      },

      isRenewal: function(membership) {
        return this.renewPurchaseTypes.includes(membership.itemType);
      },
      
      isUpgradeDowngrade: function(membership) {
        return this.upgradeDowngradePurchaseTypes.includes(membership.itemType);
      }

    };

}]);
